
import { Component } from "vue-property-decorator";
import Table from "@/components/Table.vue";
import Header from "@/components/Header.vue";
import ManagementFooter from "@/components/ManagementFooter.vue";
import CheckAdminLogin from "@/utils/CheckAdminLogin";

@Component({
  name: "OperatorsManagement",
  components: {
    Table,
    Header,
    ManagementFooter,
  },
})
export default class OperatorsManagement extends CheckAdminLogin {}
